export function supportCntrlClick(event: any, url: string) {
  if (event.ctrlKey || event.metaKey || event.mousedown || event.button === 1) {
    return window.open(url, '_blank');
  } else {
    return (window.location.href = url);
  }
}
export function capitalizeFirstLetter(val: string) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
